<template>
  <div class="row m-0">
    <div class="col-12 p-3 mt-3 card dropshadow">
      <a
        class=""
        href=""
        role="button"
        aria-controls="collapseExample"
        @click.prevent="paymentOptions"
        id="checkout-payment"
								data-test="paymentOptionLink"
      >
        <h4
          class="m-0"
          id="checkout-payment-heading"
										data-test="paymentOptionHead"
        >
          3. Payment
        </h4>
      </a>
      <div
        class="collapse"
        id="collapse-payment"
      >
							<div class="d-block mt-3">
								<hr>
								<apply-gift-card-form
									@giftCardValidate="giftCardNumberValidate($event)" />
								<br>
							<payment-gateway-selector />
							</div>
      </div>
    </div>
  </div>
</template>

<script>
import { orderApi } from '@/services/ApiServices/orderApi'
import { mapActions } from 'vuex'
import PaymentGatewaySelector from './PaymentGatewaySelector'
import ApplyGiftCardForm from '../forms/ApplyGiftCardForm'

export default {

	// beforeMount() {
	//   orderApi.orderProduct();
	// },
	props: {
		step: {
			type: Number,
			default: 0
		}
	},
	components: {
		ApplyGiftCardForm,
		PaymentGatewaySelector
	},
	methods: {
		...mapActions('user', [
			'setGiftAmountData',
			'setGiftCardNo',
			'setGiftCardPin',
			'setCoinRedeemValue',
			'clearGiftCardNo',
			'clearGiftCardPin'
		]),
		giftCardNumberValidate (cardData) {
			this.setGiftCardNo(cardData.giftCardNumber)
			this.setGiftCardPin(cardData.giftCardPin)
			orderApi.giftCardValidate(cardData)
				.then(res => {
					this.setGiftAmountData(res.data)
					this.updateGiftCardQuantity()
					this.updateGiftCardCartQuantity()
				})
				.catch(() => {
					this.clearGiftCardNo()
					this.clearGiftCardPin()
				})
		},
		paymentOptions () {
			if (this.step >= 3) {
				this.$emit('payment')
				$('#collapse-address')
					.collapse('hide')
				$('#collapse-summary')
					.collapse('hide')
				$('#collapse-payment')
					.collapse('show')
			}
		}
	}
}
</script>
